import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";
import { Http, Routes } from "../../utils/constants";
import { fetchEmailChangeConfirm, fetchUserInfo } from "../../utils/helpers/api";

const EmailChange: React.FC = () => {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const ticketEmailChange = searchParams.get("ticket") ?? "";
  const { setStateValue, globalState, setGlobalState, refreshAccessToken } = useGlobalState();
  const { user } = globalState;

  useEffect(() => {
    if (user?.user_id && ticketEmailChange) {
      handleEmailChangeConfirm(user?.user_id, ticketEmailChange);
    }
  }, [user?.user_id]);

  const handleEmailChangeConfirm = async (
    user_id: string,
    ticketEmailChange: string
  ) => {
    setStateValue("loader", true);

    try {
      const result = await fetchEmailChangeConfirm(
        user_id ?? "",
        ticketEmailChange
      );
      await refreshAccessToken();
      if (result?.status === Http.SUCCESS_CODE) {
        const resultUserInfo = await fetchUserInfo();
        if (resultUserInfo?.status === Http.SUCCESS_CODE) {
          setGlobalState({
            ...globalState,
            user: {
              ...resultUserInfo?.data.userdata
            }
          });
          nav(Routes.EMAILSETTING);
        } else {
          nav(Routes.USER);
        }
      } else {
        nav(Routes.USER);
      }
    } catch (error) {
      nav(Routes.USER);
    } finally {
      setStateValue("loader", false);
    }
  };

  return <></>;
};

export default EmailChange;
